import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
// const Index = () => import ('@/components/index')
import User from '@/components/user/user'
// const User = () => import ('@/components/user/user')
import NoticeItem from '@/components/notice/details'
// const NoticeItem = () => import ('@/components/notice/details')
import Addbank from '@/components/banks/addbank'
// const Addbank = () => import ('@/components/banks/addbank')
import Editbank from '@/components/banks/editbank'
// const Editbank = () => import ('@/components/banks/editbank')
import Agency from '@/components/agency/agency'
// const Agency = () => import ('@/components/agency/agency')
import Card from '@/components/card/card'
// const Card = () => import ('@/components/card/card')
import Loan from '@/components/loan/loan'
// const Loan = () => import ('@/components/loan/loan')
import Profit from '@/components/profit/profit'
// const Profit = () => import ('@/components/profit/profit')
import Promo from '@/components/promo/promo'
// const Promo = () => import ('@/components/promo/promo')
import Scan from '@/components/scan/scan'
// const Scan = () => import ('@/components/scan/scan')
import Award from '@/components/award/award'
// const Award = () => import ('@/components/award/award')
import Ranking  from '@/components/ranking/ranking'
// const Ranking = () => import ('@/components/ranking/ranking')
import About from '@/components/about/about'
import Culture from '@/components/about/culture'
import Introduction from '@/components/about/introduction'
import Join from '@/components/join/join'
import Fristagency from '@/components/service/fristagency'
import Mypromote from '@/components/service/mypromote'
import Personal from '@/components/service/personal'
import Resources from '@/components/service/resources'
import Login from '@/components/login/login2'
import Reg from '@/components/reg/reg2'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Index',
    //   component: Index
    // },
    {
      path: '/',
      name: 'User',
      component: User
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Reg',
      name: 'Reg',
      component: Reg
    },
    {
      path: '/NoticeItem',
      name: 'NoticeItem',
      component: NoticeItem
    },
    {
      path: '/User',
      name: 'User',
      component: User
    },
    {
      path: '/Addbank',
      name: 'Addbank',
      component: Addbank
    },
    {
      path: '/Editbank',
      name: 'Editbank',
      component: Editbank
    },
    {
      path: '/Agency',
      name: 'Agency',
      component: Agency
    },
    {
      path: '/Card',
      name: 'Card',
      component: Card
    },
    {
      path: '/Loan',
      name: 'Loan',
      component: Loan
    },
    {
      path: '/Profit',
      name: 'Profit',
      component: Profit
    },
    {
      path: '/Promo',
      name: 'Promo',
      component: Promo
    },
    {
      path: '/Scan',
      name: 'Scan',
      component: Scan
    },
    {
      path: '/Award',
      name: 'Award',
      component: Award
    },
    {
      path: '/Ranking',
      name: 'Ranking',
      component: Ranking
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/Culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/Introduction',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/Join',
      name: 'Join',
      component: Join
    },
    {
      path: '/Fristagency',
      name: 'Fristagency',
      component: Fristagency
    },
    {
      path: '/Mypromote',
      name: 'Mypromote',
      component: Mypromote
    },
    {
      path: '/Personal',
      name: 'Personal',
      component: Personal
    },
    {
      path: '/Resources',
      name: 'Resources',
      component: Resources
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js